import React from 'react';
import { TaskGeoTrackingEvents } from '@dispatch/shared/types';
import { isEmpty } from 'lodash';

export const useGetGeoStatus = (events: TaskGeoTrackingEvents[]) => {
  const [status, setStatus] = React.useState<string | undefined>(undefined);

  React.useEffect(() => {
    if (!isEmpty(events)) {
      const sortedGeoEvents = events?.sort((a, b) => {
        const timestampA = typeof a.timestamp === 'number' ? a.timestamp : 0;
        const timestampB = typeof b.timestamp === 'number' ? b.timestamp : 0;
        return timestampA - timestampB;
      });

      setStatus(
        sortedGeoEvents?.[sortedGeoEvents.length - 1]?.eventType || undefined
      );
    }
  }, [events]);

  return {
    status,
  };
};
